<template>
  <div>
    <v-data-iterator
      :items="events"
      item-key="meta.id"
      sort-by="duration.start.firebaseFormat"
      :sort-desc="false"
      :footer-props="footerProps"
      :items-per-page="25"
      no-data-text="Keine Veranstaltungen vorhanden"
    >
      <template v-slot:header>
        <slot name="header"></slot>
      </template>
      <template v-slot:default="props">
        <v-card>
          <v-list>
            <div v-for="event in props.items" :key="event.meta.id">
              <v-list-item
                v-if="event && event.userResponse && event.userResponse.status"
                link
                :to="{
                  name: 'scheduling-event-details-tab-general',
                  params: { itemId: event.meta.id },
                }"
              >
                <div
                  v-if="
                    checkPermission(manageOwnResponsePermission) &&
                    event.userResponse &&
                    event.userResponse.status
                  "
                  class="statusDisplay"
                  v-bind:style="createStatusStyle(event.userResponse.status.id)"
                ></div>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-medium mb-1">
                    <v-icon
                      v-if="
                        $store.state.user.user.settings.accessability
                          .useColorblindMode
                      "
                      small
                      :color="statusColorAsHex(event.userResponse.status.id)"
                      class="mr-2"
                    >
                      {{ statusIcon(event.userResponse.status.id) }}
                    </v-icon>
                    <span>{{ event.title }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <p style="line-height: 1.6" class="mb-0">
                      <v-icon small left>mdi-calendar-badge</v-icon
                      >{{ event.type.title }}
                      <br />
                      <v-icon small left>mdi-calendar-clock</v-icon
                      >{{ event.duration.start.timestamp }} bis
                      {{
                        tryToDisplayOnlyEndTime(
                          event.duration.start.firebaseFormat,
                          event.duration.end.firebaseFormat,
                          event.duration.end.timestamp
                        )
                      }}<br />
                      <v-icon v-if="event.location.name" small left>{{
                        textIsUrl(event.location.name)
                          ? "mdi-link-variant"
                          : "mdi-map-marker"
                      }}</v-icon>
                      {{
                        textIsUrl(event.location.name)
                          ? getHostname(event.location.name)
                          : event.location.name
                      }}
                      <br />
                    </p>
                    <v-chip
                      v-if="event.config.attendance.isMandatory"
                      x-small
                      class="mt-2 mr-2 font-weight-medium red--text text--darken-4"
                      color="red lighten-4"
                      ><v-icon x-small left>mdi-alert-circle</v-icon
                      >Anwesenheitspflicht</v-chip
                    >
                    <v-chip
                      v-if="showResponsesLocked(event)"
                      x-small
                      depressed
                      class="mt-2 mr-2 font-weight-medium"
                      ><v-icon x-small left>mdi-lock</v-icon>Rückmeldungen
                      gesperrt</v-chip
                    >
                    <v-chip
                      v-if="showResponsesAreBinding(event)"
                      x-small
                      depressed
                      class="mt-2 mr-2 font-weight-medium"
                      ><v-icon x-small left>mdi-check-decagram</v-icon
                      >Rückmeldung verbindlich</v-chip
                    >
                    <v-chip
                      v-if="event.config.responses.deadline.isCustom"
                      x-small
                      depressed
                      class="mt-2 mr-2 font-weight-medium"
                      ><v-icon x-small left>mdi-clock-alert</v-icon>Veränderte
                      Rückmeldefrist</v-chip
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action-text
                  v-if="displayMode === 'detailed-list'"
                  class="hidden-sm-and-down"
                >
                  <v-card v-if="checkFeatureAvability" outlined>
                    <v-card-text class="my-n3">
                      <div>Abgegebene Rückmeldungen</div>
                      <response-statistics-card
                        small
                        marginClass="my-1"
                        :totalConfirmations="event.count.totalConfirmations"
                        :totalIfNecessary="event.count.totalIfNecessary"
                        :totalCancellations="
                          event.count.totalCancellations + event.count.totalAway
                        "
                        :totalResponses="event.count.totalResponses"
                      ></response-statistics-card> </v-card-text
                  ></v-card>
                </v-list-item-action-text>
                <v-list-item-action v-if="displayMode === 'list'">
                  <v-btn
                    color="red darken-1"
                    icon
                    :to="{
                      name: 'scheduling-event-details-tab-general',
                      params: { itemId: event.meta.id },
                    }"
                  >
                    <v-icon large> mdi-chevron-right </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-card
                v-if="
                  displayMode === 'detailed-list' &&
                  checkFeatureAvability &&
                  event &&
                  event.userResponse &&
                  event.userResponse.status
                "
                outlined
                class="mx-3 mb-2 hidden-md-and-up"
              >
                <v-card-text class="my-n3">
                  <div>Abgegebene Rückmeldungen</div>
                  <response-statistics-card
                    small
                    :totalConfirmations="event.count.totalConfirmations"
                    :totalIfNecessary="event.count.totalIfNecessary"
                    :totalCancellations="
                      event.count.totalCancellations + event.count.totalAway
                    "
                    :totalResponses="event.count.totalResponses"
                  ></response-statistics-card>
                </v-card-text>
              </v-card>
              <v-card
                v-if="
                  displayMode === 'detailed-list' &&
                  checkPermission(manageOwnResponsePermission) &&
                  (showEditResponseBtn(event) || showCancelResponseBtn(event))
                "
                flat
                tile
              >
                <v-chip
                  v-if="event.userResponse.isAccepted"
                  label
                  small
                  class="font-weight-medium ml-5 mr-2 mb-2 orange--text text--darken-4"
                  color="orange lighten-4"
                  ><v-icon left small>mdi-star</v-icon>Eingeteilt</v-chip
                >
                <v-chip
                  v-if="event.userResponse.assignedPosition.comboId"
                  label
                  small
                  class="font-weight-medium mb-2 mr-2"
                  ><v-icon left small>mdi-fire-truck</v-icon
                  >{{ event.userResponse.assignedPosition.unit.title }}
                  –
                  {{
                    event.userResponse.assignedPosition.position.shortTitle
                  }}</v-chip
                >
                <v-chip
                  v-if="event.userResponse.assignedPosition.custom.text"
                  label
                  small
                  class="font-weight-medium mr-2 mb-2"
                  >{{ event.userResponse.assignedPosition.custom.text }}</v-chip
                >
                <!-- <v-card flat class="mx-0 px-0">
                              <v-card-text class="my-0 py-0"> -->
                <v-container
                  v-if="event.userResponse.comment"
                  fluid
                  class="my-0 py-0"
                >
                  <v-row dense>
                    <v-col class="my-0 py-0">
                      <v-chip x-small outlined class="font-weight-medium">
                        <v-icon x-small left>mdi-comment-text</v-icon
                        ><span class="text-truncate">{{
                          event.userResponse.comment
                        }}</span>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-container>
                <!-- </v-card-text>
                            </v-card> -->
                <event-response-quick-editor
                  v-if="
                    checkPermission(manageOwnResponsePermission) &&
                    showEditResponseBtn(event)
                  "
                  :event="event"
                  class="mb-1"
                ></event-response-quick-editor>
                <v-card-actions
                  v-if="showCancelResponseBtn(event)"
                  class="pt-1 mx-3"
                >
                  <v-btn
                    v-if="showCancelResponseBtn(event)"
                    small
                    depressed
                    color="error"
                    :to="{
                      name: 'scheduling-event-details-tab-general',
                      params: { itemId: event.meta.id },
                    }"
                    ><v-icon small left>mdi-run-fast</v-icon>Teilnahme
                    absagen</v-btn
                  >
                </v-card-actions>
              </v-card>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
// import { Timestamp } from "@/firebase.js";
import { SCHEDULING_EVENTS_RESPONSES_OWN_update } from "@/data/permission-types.js";
import ResponseStatisticsCard from "@/components/scheduling/ResponseStatisticsCard.vue";
import EventResponseQuickEditor from "@/components/scheduling/EventResponseQuickEditor.vue";
export default {
  name: "events-list",
  props: {
    displayMode: {
      type: String,
      default: "detailed-list",
      required: true,
    },
    events: {
      required: true,
    },
    userUid: {
      type: String,
      required: true,
    },
    userGroupId: {
      type: String,
      required: true,
    },
    userDivisionId: {
      type: String,
      required: true,
    },
  },
  components: { ResponseStatisticsCard, EventResponseQuickEditor },
  data() {
    return {
      footerProps: {
        "items-per-page-options": [25, 50, 100, -1],
      },
      manageOwnResponsePermission: `${SCHEDULING_EVENTS_RESPONSES_OWN_update}`,
    };
  },
  //   model: {
  //     prop: "response",
  //     event: "responseChange",
  //   },
  computed: {
    checkFeatureAvability() {
      return this.$store.getters["organization/checkFeatureAvailabilityById"](
        "showEventResponsesCount"
      );
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {},
    textIsUrl(text) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return urlRegex.test(text);
    },
    getHostname(url) {
      return new URL(url).hostname;
    },
    checkMultiplePermissions(items) {
      if (items && items.length > 0) {
        return false;
      } else {
        //return true;
        return this.$store.getters["organisation/checkPermissionByMultipleIds"](
          items
        );
      }
    },
    tryToDisplayOnlyEndTime(startTimestamp, endTimestamp, endTimestampString) {
      const startDate = startTimestamp.toDate();
      const endDate = endTimestamp.toDate();

      if (
        startDate.getDate() === endDate.getDate() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear()
      ) {
        return endDate.toLocaleTimeString("de-DE", {
          hour: "2-digit",
          minute: "2-digit",
        });
      }

      return endTimestampString;
    },
    statusIcon(item) {
      switch (item) {
        case "-0":
          return "mdi-cancel";
        case "0":
          return "mdi-help";
        case "1":
          return "mdi-check";
        case "2":
          return "mdi-close";
        case "3":
          return "mdi-minus";
        case "4":
          return "mdi-airplane";
        case "":
          return "mdi-alert-outline";
        default:
          return "";
      }
    },
    statusColor(item) {
      switch (item) {
        case "-0":
          return "purple darken-2";
        case "0":
          return "blue-grey darken-2";
        case "1":
          return "success";
        case "2":
          return "error";
        case "3":
          return "warning";
        case "4":
          return "info";
        case "":
          return "blue-grey darken-2";
        default:
          return "";
      }
    },
    statusColorAsHex(item) {
      switch (item) {
        case "-0":
          return "#7B1FA2";
        case "0":
          return "#455a64";
        case "1":
          return "#4caf50";
        case "2":
          return "#ff5252";
        case "3":
          return "#fb8c00";
        case "4":
          return "#2196f3";
        case "":
          return "#455a64";
        default:
          return "";
      }
    },
    createStatusStyle(status) {
      if (!status) {
        console.error("Status is undefined");
        return "";
      }
      return `background-color: ${this.statusColorAsHex(status)}`;
    },
    showResponsesAreBinding(event) {
      if (!event) {
        console.error("Event is undefined - showResponsesAreBinding");
        return false;
      }
      return this.userIsInvited(event) && event.config.responses.areBinding;
    },
    showEditResponseBtn(event) {
      if (!event || !event.userResponse || !event.userResponse.status) {
        console.error("Event is undefined - showEditResponseBtn");
        return false;
      }

      const userResponseStatusIsZero = event.userResponse.status.id == "0";
      const responsesAreBinding = event.config.responses.areBinding;
      return (
        this.userIsInvited(event) &&
        !event.config.responses.areLocked &&
        !event.deadlineIsExpired &&
        ((userResponseStatusIsZero && responsesAreBinding) ||
          !responsesAreBinding)
      );
    },
    showCancelResponseBtn(event) {
      if (!event || !event.userResponse || !event.userResponse.status) {
        console.error("Event is undefined - showCancelResponseBtn");
        return false;
      }
      const eventHasStarted =
        new Date().getTime() > event.duration.start.timestampToDate;
      const userResponseStatus =
        event.userResponse.status.id === "1" ||
        event.userResponse.status.id === "3";
      return (
        this.organizationAllowsCancellationNotice &&
        this.userIsInvited(event) &&
        !eventHasStarted &&
        !event.userResponse.isCanceled &&
        (event.deadlineIsExpired || event.config.responses.areBinding) &&
        userResponseStatus
      );
    },
    showResponsesLocked(event) {
      if (!event) {
        console.error("Event is undefined - showResponsesLocked");
        return false;
      }
      return (
        this.userIsInvited(event) &&
        event.config.responses.areLocked &&
        !event.deadlineIsExpired
      );
    },
    checkPermission(item) {
      if (item == "" || item == undefined) {
        return true;
      } else {
        return this.$store.getters["organization/checkPermissionByID"](item);
      }
    },
    userIsInvited(event) {
      if (!event.config.attendance.isLimited) {
        return true;
      }

      const allowedAttendees = event.config.attendance.allowedAttendeesIds;

      return (
        allowedAttendees.includes("all") ||
        allowedAttendees.includes(this.userUid) ||
        allowedAttendees.includes(this.userGroupId) ||
        allowedAttendees.includes(this.userDivisionId)
      );
    },
  },
};
</script>

<style>
.statusDisplay {
  height: 80px;
  width: 8px;
  border-radius: 0px 40px 40px 0px;
  margin-left: -16px;
  margin-right: 10px;
}
</style>
